import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useConfigSlice } from '../../../store/slices/config/selectors';
import { redirectParentIframe } from '../../../utils/redirect';
import { Button, ButtonVariant } from '../../controls/button/Button';

import { BlockingModalContent } from './BlockingModalContent';

export const SessionExpiredConnected: FC = (): ReactElement => {
  const isSisalEnabled = useConfigSlice.casinoConfig()?.isSisalEnabled;
  const homeUrl = useConfigSlice.casinoConfig()?.homeUrl;

  const action = homeUrl
    ? [
        <Button
          key="OK"
          tk="OK"
          variant={ButtonVariant.ACCENT}
          onClick={() => {
            redirectParentIframe(homeUrl);
          }}
        />,
      ]
    : [];

  return (
    <BlockingModalContent title={<L10nText tk="PP_7" />} actions={action}>
      <L10nText tk={isSisalEnabled ? 'ERROR_SISAL_9018' : 'SESSION_EXPIRED'} />
    </BlockingModalContent>
  );
};
